export default __webpack_public_path__ + "static/media/2x.2e76e7d8.svg";